import { BASE_BACKEND_URL } from '../backend/constants';
import { LanguageRequestBody, SetLanguageResponse } from '../backend/openapi/api-types';
import { useLanguage } from '../../core/i18n/hooks/use-language';
import { useAuthenticatedMutation } from '../backend/hooks/use-authenticated-mutation';

const userUrls = {
  changePassword: () => `${BASE_BACKEND_URL}/users/self/language` as const,
};

export const useLanguageRequest = () => {
  const currentLanguage = useLanguage();

  return useAuthenticatedMutation<SetLanguageResponse, LanguageRequestBody>({
    url: userUrls.changePassword(),
    method: 'PUT',
    language: currentLanguage,
  });
};
